import { client } from "../utils/netlify";
import { reportError } from "@/helpers/errorHelper";
import { generalConstants } from "@/utils/constants";
import { useSelector } from "react-redux"

export const getUserYotpoDetailsAPI = async (request) => {
  try{
    const resp = await client("get-yotpo-customer", request)
    return resp;
  }catch(error){
    reportError('Error in getUserYotpoDetails')
    reportError(error)
  }
};

export const getUserYotpoDetails = async (request) => {
  try{
    let current_date = new Date();
    let yotpoDetails = await getUserYotpoDetailsAPI(request);
    let yotpo_present = yotpoDetails && yotpoDetails.vip_tier_expiration == null ? true : false;
    if(yotpoDetails.vip_tier_expiration != null) {
      let expiration_date = new Date(yotpoDetails.vip_tier_expiration);
      if(current_date < expiration_date) {
        yotpo_present = true;
      }else {
        yotpo_present = false;
      }
    }
    yotpoDetails.yotpo_tier_image = '';
    yotpoDetails.yotpo_hero_image = '';
    if(yotpo_present && yotpoDetails.vip_tier_name) {
      let tier_name = yotpoDetails.vip_tier_name.toLowerCase();
      yotpoDetails.yotpo_tier_image = generalConstants.yotpo_tier_images[tier_name];
      yotpoDetails.yotpo_hero_image = generalConstants.yotpo_hero_images['desktop'][tier_name];
      yotpoDetails.yotpo_hero_image_mobile = generalConstants.yotpo_hero_images['mobile'][tier_name];
    } else {
      yotpo_present = false;
      let tier_name = generalConstants.yotpo_default_tier;
      yotpoDetails.yotpo_hero_image = generalConstants.yotpo_hero_images['desktop'][tier_name];
      yotpoDetails.yotpo_hero_image_mobile = generalConstants.yotpo_hero_images['mobile'][tier_name];
    }
    yotpoDetails.yotpo_present = yotpo_present;
    return yotpoDetails;
  }catch(error){
    reportError('Error in getUserYotpoDetails')
    reportError(error)
  }
};

export const calculateTierPoints = (price,tier) => {
  return tier&&tier.vip_tier_name ? Math.floor(generalConstants.yotpo_tier_base_points[tier.vip_tier_name.toLowerCase()]*price): Math.floor(generalConstants.yotpo_tier_base_points[generalConstants.yotpo_default_tier]*price);
}

export const getUserTierInfo = () => {
  const userState = useSelector((state) => state.loginUser);
  let userTierLevel;
  //OS-3366 : Set reward level targeting only for logged in users
  if (userState.user_loggedIn) {
    // When user logged in 
    if (userState?.yotpoDetails?.vip_tier_name === "Level 1") {
      userTierLevel = "swell_vip_level_1";
    }
    else if (userState?.yotpoDetails?.vip_tier_name === "Level 2") {
      userTierLevel = "swell_vip_level_2";
    }
    else {
      userTierLevel = "swell_vip_level_3";
    }
  }
  return userTierLevel;
}